

























































































import { getExchangeDetailApi, agreeExchangeApi } from "@/api/integral";
import { dateFormat } from "@/utils/timeFormat";
import cancelDialog from "./cancelDialog.vue";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  name: "integralExchangeDetail",
  components: {
    cancelDialog,
  },
})
export default class extends Vue {
  @Prop() orderId!: number;
  form: any = {};
  dialogVisible: boolean = false;
  openDialog() {
    getExchangeDetailApi({ order_id: this.orderId }).then((res: any) => {
      res.data.create_time = dateFormat(
        "YYYY-mm-dd HH:MM",
        res.data.create_time * 1000
      );
      res.data.update_time = dateFormat(
        "YYYY-mm-dd HH:MM",
        res.data.update_time * 1000
      );
      this.form = res.data;
    });
    this.dialogVisible = true;
  }
  closeDialog() {
    this.dialogVisible = false;
  }
  handleExchange() {
    this.$confirm(
      "请确定商品库存信息，完成兑换后自动扣除积分，且不能取消。确定要兑换商品？",
      `确定兑换 - ${this.form.goods.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        agreeExchangeApi({ order_id: this.orderId }).then(() => {
          this.$message({
            type: "success",
            message: "兑换成功!",
          });
          this.closeDialog();
        });
      })
      .catch(() => {});
  }
}
